import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  HourglassOutlined
} from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import { IComplementaryActivityHours } from 'interfaces/complementary_activities';
import { ReactNode } from 'react';

interface HoursTileProps {
  icon: ReactNode;
  label: string;
  value?: number;
  tileClass: string;
  iconClass: string;
}

const HoursTile = ({
  icon,
  label,
  value,
  tileClass,
  iconClass
}: HoursTileProps) => (
  <div
    className={`flex items-center gap-3 rounded-lg border border-solid px-3 py-2 ${tileClass}`}
  >
    <div
      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-base ${iconClass}`}
    >
      {icon}
    </div>
    <div className="flex flex-col leading-tight">
      <Typography.Text type="secondary" className="text-xs">
        {label}
      </Typography.Text>
      <Typography.Text strong className="text-lg leading-none">
        {value === undefined ? (
          '-'
        ) : (
          <>
            {value}
            <span className="text-xs font-medium">h</span>
          </>
        )}
      </Typography.Text>
    </div>
  </div>
);

interface ComplementaryActivityHoursSummaryProps {
  hours: IComplementaryActivityHours | null;
}

// Tons da paleta do tema (configs/antd.ts): neutro gray, sucesso emerald, aviso yellow.
export const ComplementaryActivityHoursSummary = ({
  hours
}: ComplementaryActivityHoursSummaryProps) => (
  <Row gutter={[12, 12]}>
    <Col xs={24} md={8}>
      <HoursTile
        icon={<ClockCircleOutlined />}
        label="Horas mínimas exigidas"
        value={hours?.required_hours}
        tileClass="border-gray-200 bg-gray-50"
        iconClass="bg-gray-100 text-gray-600"
      />
    </Col>
    <Col xs={24} md={8}>
      <HoursTile
        icon={<CheckCircleOutlined />}
        label="Horas aprovadas"
        value={hours?.completed_hours}
        tileClass="border-emerald-200 bg-emerald-50"
        iconClass="bg-emerald-100 text-emerald-600"
      />
    </Col>
    <Col xs={24} md={8}>
      <HoursTile
        icon={<HourglassOutlined />}
        label="Horas a cumprir"
        value={hours?.remaining_hours}
        tileClass="border-yellow-200 bg-yellow-50"
        iconClass="bg-yellow-100 text-yellow-600"
      />
    </Col>
  </Row>
);
